export const GAP: Record<string, string> = {
  none: '0',
  xs:   '0.25rem',
  sm:   '0.5rem',
  md:   '1rem',
  lg:   '1.5rem',
  xl:   '2rem',
  '2xl': '3rem',
};

export const PAD: Record<string, string> = { ...GAP };

export const CONTAINER_MAX: Record<string, string> = {
  xs:   '480px',
  sm:   '640px',
  md:   '768px',
  lg:   '1024px',
  xl:   '1280px',
  '2xl': '1536px',
  full: '100%',
};

export const BREAKPOINTS = ['default', 'sm', 'md', 'lg', 'xl'] as const;
export type Breakpoint = typeof BREAKPOINTS[number];

export const ROLE_MAP: Record<string, string> = {
  header:  'banner',
  footer:  'contentinfo',
  nav:     'navigation',
  main:    'main',
  aside:   'complementary',
  section: 'region',
  article: 'article',
  form:    'form',
  list:    'list',
};
